import classNames from 'classnames';
import React from 'react';
import './Card.scss';
function Card({ title, floating, children }) {
    const classes = classNames({
        'common-ui-card': true,
        'common-ui-card__floating': floating,
    });
    return (React.createElement("div", { className: classes },
        title && React.createElement("h2", { className: "common-ui-card__title" }, title),
        children));
}
export default Card;
